'use strict';

import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

import styles from './assets/indexResponse.module.css';
import './assets/private_header.css';



class LazyImage extends Component {
  state = {};
  setValue(val) { }

  onlazyloadImg = () => {
    const lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
    if ("IntersectionObserver" in window) {
      const lazyImageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.classList.add("fade-in");
            lazyImage.classList.remove("lazy");
            lazyImageObserver.unobserve(lazyImage);
          }
        });
      });

      lazyImages.forEach(function (lazyImage) {
        setTimeout(() => {
          lazyImageObserver.observe(lazyImage);
        }, 200)

      });
    }

  }

  render() {
    let imgUrl = this.props.imgUrl;
    return (
      <img loading="lazy" src={require('./assets/img/placeholder.jpg')} data-src={imgUrl} className={this.props.className ? `${this.props.className} lazy` : "lazy"} onLoad={() => this.onlazyloadImg()} {...this.props.className} />
    );
  }
}
export default LazyImage;
